const CONFIG = {
    API_BASE_URL: '/api/',
    mapbox: {
        baseApiUrl: 'https://maptest.realty.com',
        accessToken: 'pk.eyJ1IjoiYWxnaWIiLCJhIjoiNGJiNjA4Mzc4MjJlMzE5MmJjOWU3YzhjMDJiNGUyOTAifQ.xS7af1lnEL593DZ3f0mOJA'
    }
};

export default CONFIG;
